import React, { useState, useEffect } from 'react';
import GamesContainer from './GamesContainer';
import gamesService from '../../gameData/services/gamesService';

function GamesList(props) {
  const [sortsData, setSortsData] = useState([]);
  const [timeFiltersData, setTimeFiltersData] = useState([]);
  const [pageContext, setPageContext] = useState({});
  useEffect(() => {
    let isSubscribed = true;
    gamesService.getGamesSorts(null, true).then(
      result => {
        if (isSubscribed) {
          setPageContext(result?.pageContext);
          setTimeFiltersData(result?.timeFilters);
          if (result?.sorts) {
            setSortsData(result.sorts);
          }
        }
      },
      error => {
        console.debug(error);
      }
    );
    return () => {
      isSubscribed = false;
    };
  }, []);

  return (
    <div>
      {sortsData.length > 0 &&
        sortsData.map((sort, index) => {
          return (
            <GamesContainer
              sortPosition={index}
              sort={sort}
              pageContext={pageContext}
              timeFilters={timeFiltersData}
              key={sort.token + sort.displayName}
              {...props}
            />
          );
        })}
    </div>
  );
}

export default GamesList;
